import React from "react";

import Education from "./Education";
import Experience from "./Experience";
import Skills from "./Skills";
import "./Resume.scss";

export default function ResumeMainComponent() {
      return(
          <div className="flex-column w-100 h-100 d-flex  resume-main">
                <p className="header-main m-4">Education</p>
                <Education
                    schoolName="Christ Church Boys College"
                    startYear="2003" endYear="2015"
                    schoolDescription="I have studied in G/Christ Church Boys College from grade 1 to grade 11. I was able to obtain 8A's and 1B for G.C.E. Ordinary Level Examination. With that result I have left my first school to study for G.C.E. Advanced Level Examination."
                />
                <Education
                    schoolName="Richmond College Galle"
                    startYear="2015" endYear="2018"
                    schoolDescription="I have studied at Richmond College Galle for my G.C.E. Advanced Level Examination. I have studied in 'Common Stream'. The subjects that I have studied are Physics, Combined Mathematics, General English, and I.C.T. I was able to obtain 3A's and 1B's for Advanced Level Examination. Through that result, I was able to enter the degree of BSc. in Information Technology offered by, the University of Moratuwa, Faculty of Information Technology."
                />
                <Education
                    schoolName="University of Moratuwa"
                    startYear="2019" endYear="Present"
                    schoolDescription="I am currently studying at the University of Moratuwa, Faculty of Information Technology. I'm a 2nd-year student. I'm hoping to specialize my degree into Data-Science."
                />
                <hr />
                <p className="header-main m-4">Volunteering and Experiences</p>
                <Experience
                    pName="UoM-Table Tennis Team"
                    startYear="2019" endYear="Present"
                    pDescription="I had the privilege to join the University of Moratuwa, Table Tennis Team.  We have been able to achieve huge success through recent times. Also, UoM-Table Tennis Team was able to obtain the Dual Championship in the last two consecutive SLUGs."
                />
              <Experience
                  pName="Medium Content Writer"
                  startYear="2019" endYear="Present"
                  pDescription="I am weekly updating my blog at Medium. All the posts that I'm sharing through medium will be about programming and data science."
              /><hr />
                <p className="header-main m-4">Skills</p>
                <Skills />
          </div>
      );
}
